export default __webpack_public_path__ + "static/media/desktop.90290654.jpg";